<div class="animate__animated animate__fadeInRight">
    <br />
  
    <div class="col">
      <mat-card class="mat_card_general">
        <h1 class>Modulo Tipo de Préstamo</h1>
      </mat-card>
    </div>
  
    <br />
    <mat-card class="mat-elevation-z5 mat_card_general_content">
      <app-agregar-tipoprestamo
      (onDebounce)="actualizarTabla($event)"
      ></app-agregar-tipoprestamo>
      <br />
      <app-lista-tipoprestamo
      (onDebounce)="actualizarTabla($event)"
      [tipoprestamos_list]="tprestamo"
      ></app-lista-tipoprestamo>
    </mat-card>
    <hr />
  </div>
  